
  (function () {
    // Nombre del evento con el que el carrito de Horizon se vuelve a pintar solo.
    var evento = null;
    try { import('@shopify/events').then(function (m) { evento = m.StandardEvents && m.StandardEvents.cartLinesUpdate; }).catch(function () {}); } catch (x) {}

    document.addEventListener('click', function (e) {
      var b = e.target.closest('.db-upsell__btn'); if (!b) return;
      b.disabled = true; b.textContent = 'Agregando…';
      var alta = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.variant, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
      if (evento) {
        var ev = new Event(evento, { bubbles: true });
        ev.promise = alta.then(function () { return { detail: {} }; });
        document.dispatchEvent(ev);
        alta.then(function () { b.textContent = '✓ Agregado'; })
          .catch(function () { b.disabled = false; b.textContent = '+ Agregar'; });
        return;
      }
      alta.then(function () { try { sessionStorage.setItem('db-abrir-carrito', '1'); } catch (x) {} location.reload(); })
        .catch(function () { b.disabled = false; b.textContent = '+ Agregar'; });
    });
    try {
      if (sessionStorage.getItem('db-abrir-carrito')) {
        sessionStorage.removeItem('db-abrir-carrito');
        window.addEventListener('load', function () {
          var c = document.querySelector('[href="/cart"], .header-actions__cart-icon, cart-icon, [aria-controls*="cart"]');
          if (c) setTimeout(function () { c.click(); }, 400);
        });
      }
    } catch (x) {}
  })();
